import MenuItem from "@mui/material/MenuItem";
import Menu from "@/components/menu";
import UISelect from "@/components/ui-controls/select";
import { useDispatch, useSelector } from "react-redux";
import {
  getSpecificGeneralInfo,
  setGeneralState,
} from "@/store/slices/general/generalSlice";
import { ThemePalettes } from "@/services/theme-palettes";
import { camelCaseStringToNormalText } from "@/services/generic.methods";
import { globalLogout } from "@/services/generic-logout-method";
import { useRouter } from "next/navigation";
import { faBuilding, faUser } from "@fortawesome/free-regular-svg-icons";
import GetIcon from "@/components/font-awesome-icon";
import {
  faAngleRight,
  faKey,
  faPowerOff,
  faSwatchbook,
} from "@fortawesome/free-solid-svg-icons";
import { Typography } from "@mui/material";
import storage from "@/services/storage";
import TruncateTooltip from "@/components/truncate-with-tooltip";
import { getUserCompaniesCount } from "@/store/slices/auth/authSlice";

const ProfileMenu = ({
  anchorEl,
  isMenuOpen,
  handleMenuClose,
  handleTheme,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const currentCompany = JSON.parse(storage.getItem("Profile"))?.CompanyName;
  const theme = useSelector(getSpecificGeneralInfo("theme"));
  const companiesCount = useSelector(getUserCompaniesCount);
  const menuId = "primary-search-account-menu";

  const logoutHandler = () => {
    let shouldRedirect = true;
    globalLogout(shouldRedirect);
    handleMenuClose();
  };

  const handleCompanySwitch = () => {
    handleMenuClose();
    router.push("/switchcompany");
  };
  const handleProfile = () => {
    handleMenuClose();
    router.push("/crm/settings/user-profile");
  };
  const handleThemeChange = () => {
    handleMenuClose();
    handleTheme();
  };

  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      id={menuId}
      keepMounted={false}
      open={isMenuOpen}
      onClose={handleMenuClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <MenuItem key="profile" onClick={handleProfile}>
        <GetIcon
          title="Profile"
          iconStyles={{
            marginRight: "10px",
            fontSize: "1.2rem",
          }}
          icon={faUser}
        />
      </MenuItem>
      {companiesCount > 1 && (
        <MenuItem key="switchCompany" onClick={handleCompanySwitch}>
          <GetIcon
            title={
              <span>
                <Typography fontSize={".8rem"}>Switch Company</Typography>
                <Typography fontWeight={"bold"} fontSize={".8rem"}>
                  <TruncateTooltip text={currentCompany} limit={15} />
                </Typography>
              </span>
            }
            iconStyles={{
              marginRight: "10px",
              fontSize: "1.4rem",
            }}
            icon={faBuilding}
          />
          <GetIcon
            icon={faAngleRight}
            iconStyles={{
              marginLeft: "25px",
            }}
          />
        </MenuItem>
      )}
      {/* <MenuItem
        key="theme"
        // onClick={handleMenuClose}
      >
        <UISelect
          size={"small"}
          value={theme}
          clearable={false}
          onChange={(e) => dispatch(setGeneralState({ theme: e.target.value }))}
          options={Object.keys(ThemePalettes).map((t) => ({
            label: camelCaseStringToNormalText(t, "heading"),
            value: t,
          }))}
        />
      </MenuItem> */}

      <MenuItem key="theme" onClick={handleThemeChange}>
        <GetIcon
          title="Theme"
          iconStyles={{
            marginRight: "10px",
            fontSize: "1.1rem",
          }}
          icon={faSwatchbook}
        />
      </MenuItem>
      <MenuItem key="logout" onClick={logoutHandler}>
        <GetIcon
          title="Logout"
          iconStyles={{
            marginRight: "10px",
            fontSize: "1.1rem",
          }}
          icon={faPowerOff}
        />
      </MenuItem>
    </Menu>
  );
  return renderMenu;
};

export default ProfileMenu;
